﻿import { FIQAssist } from "../../app";
import { Inject, Injectable } from "@fiqas/angular-utils";
import { FiqassistApiServiceBase } from "./fiqassistApiServiceBase";
import { GetCustomersResult } from "../../models/customer";
import { User, FiqassistRole } from "../../models/user";
import { StartResult } from "../../models/home"
import { AuthenticationService } from "../authenticationService"
import { IIdentityLink } from "../../interfaces/iFqs";
import { HomeService } from "./homeService";
import { FqsService } from "../fqsService";
import { RecentServiceCasesResult } from "../../models/serviceCase";
import { Memoize } from "@fiqas/utils";
import { LogService } from "../logService";
import { GetPersonsResult } from "../../models/person";
import { retry } from "rxjs/operator/retry";
import { AuthorizationService } from "../authorizationService";
import { Subscription } from "rxjs/Subscription";

@Injectable({
    module: FIQAssist,
    selector: UserService.selector
})
export class UserService extends FiqassistApiServiceBase {
    public static selector = "UserService";

    constructor(
        @Inject('$q') $q: ng.IQService,
        @Inject('$http') $http: angular.IHttpService,
        @Inject() authenticationService: AuthenticationService,
        @Inject() authorizationService: AuthorizationService,
        @Inject() private homeService: HomeService,
        @Inject() private logService: LogService
    ) {
        super($q, $http, authenticationService, authorizationService);

        authenticationService.addLoginHandler(() => this.resetMemoizedProperties());
        authenticationService.addLogoutHandler(() => this.resetMemoizedProperties());
        authorizationService.onRoleChanged(() => this.resetMemoizedProperties());
    }

    private resetMemoizedProperties() {
        this.Customers = null;
    }

    private async getCustomers() {
        try {
            var startResult = await this.homeService.StartResult;
            if (startResult === null) return null;
            return startResult.customers.value;
        } catch (e) {
            this.logService.error('UserService', 'Error retrieving customer', e);
        }
    }

    @Memoize()
    public get Customers() {
        var p = this.getCustomers();
        p.catch(() => this.Customers = null);
        return p;
    }
    public set Customers(_) { }

    public async getFiqasEmployees() {
        try {
            var startResult = await this.homeService.StartResult;
            if (startResult === null) return null;
            var pers = startResult.persons;
            return this.performRequest<void, GetPersonsResult>("GET", pers.fullHref, {});
        } catch (e) {
            this.logService.error('UserService', 'Error retrieving fiqas employees', e);
        }
    }

    public async getPersons(customerIds: string[] = null) {
        try {
            var startResult = await this.homeService.StartResult;
            if (startResult === null) return null;
            var customers = await this.Customers;
            var pers = startResult.persons;
            return this.performRequest<void, GetPersonsResult>("GET", pers.fullHref, { cid: customerIds || customers.items.map(c => c.id.ref) });
        } catch (e) {
            this.logService.error('UserService', 'Error retrieving persons', e);
        }
    }

    public async RecentServiceCases(customers: number[], maxItems: number): Promise<RecentServiceCasesResult> {
        try {
            var startResult = await this.homeService.StartResult;
            if (startResult === null) return null;
            return this.performRequest<void, RecentServiceCasesResult>("GET", startResult.recentCases.fullHref, { cid: customers, limit: maxItems })
        } catch (e) {
            this.logService.error('UserService', 'Error retrieving recentservicecases', e);
        }
    }
}
